import { checkListItemStyles } from './CheckListItem.styles'

export function checkListItemIO() {
  return {
    styles: checkListItemStyles
  }
}
export type CheckListItemIO = ReturnType<typeof checkListItemIO>
